import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { userTutorialsReselector as stateSelector } from 'reduxModules/users/selectors'
import { tutorialsDispatchers as dispatchSelector } from 'reduxModules/users/dispatchers'
import { userTutorialsFetchMore } from '../../../redux/modules/users'
import Tutorial from '../../generic/CourseSummary'
import LoadMore from '../../generic/LoadMore'
import './styles.css'

export const MAX_MONTHLY_COURSES = {
  basic: 4,
  default: 6
}

export class Courses extends Component {
  componentDidMount() {
    this.props.loadUserTutorials()
  }

  render() {
    const { tutorials, subscription, isSubscribed, nextTutorials, loading } = this.props

    if (!tutorials) return null

    return (
      <div id="Courses" className="account-section">
        {(tutorials.length > 0 || (isSubscribed && _.size(subscription.monthlyVideosSeen) > 0)) && (
          <div className="courses">
            {isSubscribed && subscription.rank === 1 && _.size(subscription.monthlyVideosSeen) > 0 && (
              <>
                <h3 className="account-section__title">
                  Monthly Activated Courses
                  ({_.size(subscription.monthlyVideosSeen)}/
                  {subscription.plan === 'Basic'
                    ? MAX_MONTHLY_COURSES.basic
                    : MAX_MONTHLY_COURSES.default})
                </h3>
                <section className="tutorials-list-content">
                  {subscription.monthlyVideosSeen.map((tutorial) => (
                    <Tutorial
                      className="tutorial"
                      key={`tutorial-seen-${tutorial.id}`}
                      slug={tutorial.slug}
                      summary={tutorial.description}
                      teacher={tutorial.artist.title}
                      teacherSlug={tutorial.artist.slug}
                      title={tutorial.title}
                      thumb={tutorial.photo.boxThumb}
                      new={tutorial.new}
                    />
                  ))}
                </section>
              </>
            )}

            <h3 className="account-section__title">My Courses</h3>
            <section className="tutorials-list-content">
              {tutorials.map((tutorial) => (
                <Tutorial
                  className="tutorial"
                  key={`tutorial-${tutorial.id}`}
                  slug={tutorial.slug}
                  summary={tutorial.description}
                  teacher={tutorial.artist.title}
                  teacherSlug={tutorial.artist.slug}
                  title={tutorial.title}
                  thumb={tutorial.photo.boxThumb}
                />
              ))}
            </section>
          </div>
        )}
        {nextTutorials && (
          <div className="load-more">
            <LoadMore
              fetchMoreAction={userTutorialsFetchMore}
              next={nextTutorials}
              listContainerId="Courses"
            />
          </div>
        )}
        {tutorials && tutorials.length === 0 && (
          <div className="no-results">
            {!loading && <span>You haven&apos;t purchased any course streams.</span>}
            {loading > 0 && (
              <div className="spinner">
                <div className="double-bounce1" />
                <div className="double-bounce2" />
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

Courses.propTypes = {
  loadUserTutorials: PropTypes.func.isRequired,
  tutorials: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.number.isRequired,
  subscription: PropTypes.shape({
    monthlyVideosSeen: PropTypes.array,
    rank: PropTypes.number,
    plan: PropTypes.string
  }),
  isSubscribed: PropTypes.bool,
  nextTutorials: PropTypes.string
}

Courses.defaultProps = {
  tutorials: [],
  subscription: null,
  isSubscribed: false,
  nextTutorials: null
}

export default connect(
  stateSelector,
  dispatchSelector
)(Courses)
